export default [
    {
        path: "/autoreply",
        name: "autoreply_index",
        component: () => import("../views/autoreply/index.vue"),
    },
];
